import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useChCreateSickLeaveMutation as useChCreateSickLeaveMutationType } from "@/modules/patients/detail/sick-leave-certificate/ch/services/__generated__/useChCreateSickLeaveMutation.graphql"

const mutation = graphql`
  mutation useChCreateSickLeaveMutation($input: Ch_createSickLeaveInput!) {
    ch_createSickLeave(input: $input) {
      ch_SickLeave {
        id
        ...chSickLeaveFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useChCreateSickLeaveMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChCreateSickLeaveMutationType>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChCreateSickLeaveMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChCreateSickLeaveMutation }
